import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button, Container } from "react-bootstrap";
import bioAsia from "../../../assets/events/BioAsia 2024.webp";
import event2 from "../../../assets/events/symposiumonSimulatorPlatform.webp";
import event3 from "../../../assets/events/theAimlProgramDRDO.webp";
import event4 from "../../../assets/events/exploringTheIntersectionofAI.webp";
import dstTeam from "../../../assets/events/dstTeamVisit.webp";
import datapulse from "../../../assets/events/datapulse.webp";
import datapulseaprjun from "../../../assets/events/dataplusaprjun.webp";
import "./LatestatIhub.css";
import newsletter from "../../../assets/pdf/newsletter/IHUB_DATA_IIIT-H_Q1_2024_Newsletter_updated.pdf"
import newsletterJanMar from "../../../assets/pdf/newsletter/ihub_data_jan_to_mar_2024.pdf"
import mainTips from "../../../assets/events/mainTips.webp";
import ihubDataWadhwaniCard from "../../../assets/events/IHub-Data-Wadhwani-Card.webp";
import avishkar from "../../../assets/events/Avishkar.webp";
import datapulseq3 from "../../../assets/events/datapulse q3.webp";
import newsletterQ3 from "../../../assets/pdf/newsletter/IHUB DATA IIIT-H Q3 2024 Newsletter_compressed.pdf"
import dataPulsOctDec from "../../../assets/events/dataPulseOct-Dec.webp";
import newsletterOctDec from "../../../assets/pdf/newsletter/Newsletter-Oct-Dec-24.pdf"
import hdfc from "../../../assets/events/hdfc-grant.webp";
import dataplusaprile25 from "../../../assets/events/dataplusaprile25.webp";
import newsletteraprile25 from "../../../assets/pdf/newsletter/IHUB-Q1-2025-Newsletter.pdf"
export default function Events() {

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 728,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <Container>
        <h2 className="fw-bold text-center py-3" data-aos="fade-right"> Latest at IHub - Data </h2>
        <div className="latest-dv" data-aos="fade-down">

        <Slider className="home-event-slider" {...settings}>
        <div className="card-sld">
              <div className="card-int">
                <img src={dataplusaprile25} alt="" className="img-fluid w-100" />
                <h6>
                IHub-Data Newsletter Data Pulse <br/>
                (Jan to Mar 2025 edition)
                </h6>
                  {/* <h6><b>REGISTER HERE: </b><a href="https://parivartan.accubate.app/ext/form/3111/1/apply" target="__blank">https://parivartan.accubate.app/ext/form/3111/1/apply</a> </h6> */}
                  <p>
                  Launched in January 2025, India Data Org is an integrated ecosystem designed to enhance dataset sharing and model publication in artificial intelligence and machine learning (AI/ML)...
                  </p>
                <div className="red-mr-btn">
                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    href={newsletteraprile25}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
        <div className="card-sld">
              <div className="card-int">
                <img src={hdfc} alt="" className="img-fluid w-100" />
                  <h6>
                  HDFC Bank Parivartan: AI for Social Good Challenge
                  </h6>
                  {/* <h6><b>REGISTER HERE: </b><a href="https://parivartan.accubate.app/ext/form/3111/1/apply" target="__blank">https://parivartan.accubate.app/ext/form/3111/1/apply</a> </h6> */}
                  <p>
                  The HDFC Bank Parivartan Grant Challenge invites startups, innovators, and disruptors to take center stage and redefine the future through tech-driven research startups. This is your chance to...
                  </p>
                <div className="red-mr-btn">
                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    as={Link} to="/startups"
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
        <div className="card-sld">
              <div className="card-int">
                <img src={dataPulsOctDec} alt="" className="img-fluid w-100" />
                  <h6>
                  IHub-Data Newsletter Data Pulse (Oct to Dec 2024 edition)
                  </h6>
                  <p>
                  Learn about all our activities and initiatives in the last quarter of 2024 in this newsletter. Get information on ongoing Startup Funding Opportunities...
                  </p>
                <div className="red-mr-btn">
                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    href={newsletterOctDec}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          <div className="card-sld">
              <div className="card-int">
                <img src={datapulseq3} alt="" className="img-fluid w-100" />
                  <h6>
                    IHub-Data Newsletter Data Pulse (July to Sep 2024 edition)
                  </h6>
                  <p>
                  Read about the events and activities of IHub-Data in the third quarter of 2024 in the latest edition of our newsletter. Also, don't miss our blogs in this edition...
                  </p>
                <div className="red-mr-btn">
                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    href={newsletterQ3}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          <div className="card-sld">
            <div className="card-int">
              <img src={avishkar} alt="" className="img-fluid w-100" />
              <h6>
              Avishkar Winter Cohort 2024 For Medtech and Mobility
                </h6>
                <p>
                The Avishkar Winter Cohort 2024 is here to accelerate your growth! Get seed funding from IHub-Data, research support from IIITH, strategic guidance, investor...
                </p>
              <div className="red-mr-btn">
                <Button
                  className="border-0 home-btn-rd-more"
                  variant="primary"
                  as={Link} to="/startups"
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
          <div className="card-sld">
            <div className="card-int">
              <img src={ihubDataWadhwaniCard} alt="" className="img-fluid w-100" />
              <h6>
                Wadhwani Liftoff: Funding opportunity for Startups
                </h6>
                <p>
                Calling Healthcare and Mobility DeepTech AI/ML startups to raise funding and accelerate growth with Wadhwani Liftoff in collaboration with Wadhwani Foundation!...
                </p>
              <div className="red-mr-btn">
                <Button
                  className="border-0 home-btn-rd-more"
                  variant="primary"
                  as={Link} to="/startups"
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
          <div className="card-sld">
            <div className="card-int">
              <img src={mainTips} alt="" className="img-fluid w-100" />
              <h6>
                IHub-Data participated in TIPS 4.0 at IIT Bombay
                </h6>
                <p>
                IHub-Data participated in TIPS 4.0 (the 4th National Workshop on Technology Innovation in Cyber-Physical Systems) at IIT Bombay on May 13 and 14. 5 Tech...
                </p>
              <div className="red-mr-btn">
                <Button
                  className="border-0 home-btn-rd-more"
                  variant="primary"
                  as={Link} to="/events/ihub-data-participated-tips-4.0"
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
          <div className="card-sld">
            <div className="card-int">
              <img src={datapulseaprjun} alt="" className="img-fluid w-100" />
              <h6>
                IHub-Data Newsletter Data Pulse <br/>
                (April to June 2024 edition)
              </h6>
              <p>
              IHub-Data, IIIT Hyderabad showcased roadmap and
              startups at the 4th TIPS conference held at IIT Bombay.
              We hosted the Surveyor General of India...
              </p>

              <div className="red-mr-btn">
                <Button
                  className="border-0 home-btn-rd-more"
                  variant="primary"
                  target="__blank"
                  href={newsletter}
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
          <div className="card-sld">
            <div className="card-int">
              <img src={datapulse} alt="" className="img-fluid w-100" />
              <h6>
                IHub-Data Newsletter Data Pulse <br/>
                (Jan to Mar 2024 edition)
              </h6>
              <p>
              Read about all the events and updates of IHub-Data in the first quarter of 2024 here. The highlights this quarter include 
              DST Secretary Prof Abhay Karandikar's visit....
              </p>

              <div className="red-mr-btn">
                <Button
                  className="border-0 home-btn-rd-more"
                  variant="primary"
                  target="__blank"
                  href={newsletterJanMar}
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
          <div className="card-sld">
            <div className="card-int">
              <img src={dstTeam} alt="" className="img-fluid w-100" />
              <h6>
                DST Secretary Prof Abhay Karandikar launches IHub-Data's IDEA Lab
                </h6>
                <p>
                DST Secretary Prof Abhay Karandikar, NMICPS Member Secretary Dr Ekta Kapoor, NMICPS Member Convener Dr JBV Reddy visited IHub-Data at IIIT...
                </p>

              <div className="red-mr-btn">
                <Button
                  className="border-0 home-btn-rd-more"
                  variant="primary"
                  as={Link}
                  to="/events/dst-teams-visit"
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
          <div className="card-sld">
            <div className="card-int">
              <img src={bioAsia} alt="" className="img-fluid w-100" />
              <h6>
                IHub-Data team participated in BioAsia 2024
                </h6>
                <p>
                The BioAsia 2024 was hosted from February 26-28, 2024 in Hyderabad. This year the theme focused on "Data and AI: Redefining Possibilities...
                </p>

              <div className="red-mr-btn">
                <Button
                  className="border-0 home-btn-rd-more"
                  variant="primary"
                  as={Link}
                  to="/events/bio-asia-24"
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
          <div className="card-sld">
            <div className="card-int">
              <img src={event2} alt="" className="img-fluid w-100" />
              <h6>
                Symposium on Simulator Platform for Safe Driving in Indian Road Conditions
              </h6>
              <p>
                The challenges of driving on Indian roads in unique and to improve driver safety in Indian Road Conditions, we hosted a symposium on Mobility ...
              </p>

              <div className="red-mr-btn">
                <Button
                  className="border-0 home-btn-rd-more"
                  variant="primary"
                  as={Link}
                  to="/events/symposium-on-simulator-platform"
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
          <div className="card-sld">
            <div className="card-int">
              <img src={event3} alt="" className="img-fluid w-100" />
              <h6>
                AI/ML Executive Training Program for DRDO scientists
              </h6>
                <p>
                  IHub-Data successfully organised a two week AI/ML executive training program for DRDO scientists. The program was held in October, 2023 at the IIIT...
                </p>
              <div className="red-mr-btn">
                <Button
                  className="border-0 home-btn-rd-more"
                  variant="primary"
                  as={Link}
                  to="/events/the-ai-ml-program-hosted-by-ihub-Data"
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
          <div className="card-sld">
            <div className="card-int">
              <img src={event4} alt="" className="img-fluid w-100" />
              <h6>
                Prof P Anandanspoke on AI innovation for global health
              </h6>
                <p>
                Prof P. Anandan's talk on “Translating AI Innovations into Solutions for Global Health”, in January, explored the intersection of AI and global health...
                </p>
              <div className="red-mr-btn">
                <Button
                  className="border-0 home-btn-rd-more"
                  variant="primary"
                  as={Link}
                  to="/events/exploring-the-intersection-of-ai-and-global"
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
        </Slider>
        </div>
      </Container>
    </>
  );
}
